module.exports = __webpack_public_path__ + "img/haefele_logo.819eaad8.svg";